module.exports = __webpack_public_path__ + "static/media/slider-1.f2ed56bd.jpg";